import { Box, Card, Group, Image, Text, useMantineTheme } from '@mantine/core';

import { IconCalendarWeek, IconFolderPin } from '@tabler/icons-react';

import { format } from 'date-fns';

import { type OrganizationImage } from '../../types/apiTypes';

interface Props {
  image: OrganizationImage
}

const getImageSourceString = (image: OrganizationImage) => {
  if (image.extracted ?? false) {
    return 'Extracted';
  } else if (image.storage_type === 'SHAREPOINT') {
    return 'SharePoint';
  } else {
    return 'Uploaded';
  }
};
const ImageListCard: React.FC<Props> = (props: Props) => {
  const { image } = props;
  const { other: colorVars } = useMantineTheme();
  const formattedDate = format(image.updated_at ?? '', 'M/d/yy');

  return (
    <Card radius={4} withBorder w='100%' p={0} shadow="md">
      <Box style={{ position: 'relative', width: '100%', paddingBottom: '100%' }}>
        <Image
          alt={image.summary ?? ''}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          src={image.thumbnail_url}
        />
      </Box>
      <Group p={16} gap={16}>
        <Group gap={8}>
          <IconCalendarWeek color={colorVars.secondaryIconColor} size={20} />
          <Text fz='sm' fw={500} c={colorVars.secondaryTextColor}>
            {formattedDate}
          </Text>
        </Group>
        <Group gap={8}>
          <IconFolderPin color={colorVars.secondaryIconColor} size={20} />
          <Text fz='sm' fw={500} c={colorVars.secondaryTextColor}>
            {getImageSourceString(image)}
          </Text>
        </Group>
      </Group>
    </Card>
  );
};

export default ImageListCard;
